import { render } from "./ProductSpec.vue?vue&type=template&id=57c98c3a&scoped=true"
import script from "./ProductSpec.vue?vue&type=script&lang=js"
export * from "./ProductSpec.vue?vue&type=script&lang=js"

import "./ProductSpec.vue?vue&type=style&index=0&id=57c98c3a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c98c3a"]])

export default __exports__